
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Zur Gruppe der Länder mit weiterhin ungebremstem Wachstum der Ansteckungen
gehören jene mit einer `}<strong parentName="p">{`Verdopplungszeit der Fälle von weniger als 30 Tagen`}</strong>{` –
davon sind in der Grafik aus Platzgründen nur die neun Länder mit `}<strong parentName="p">{`mehr als
50’000 Fällen`}</strong>{` hervorgehoben. Ihre Kurven wachsen exponentiell, und bei den
meisten ist noch keine Abschwächung erkennbar.`}</p>
    <p>{`Zu den «Ungebremsten» gehören mit `}<strong parentName="p">{`Brasilien`}</strong>{` und `}<strong parentName="p">{`Indien`}</strong>{` zwei der zurzeit
am stärksten betroffenen Länder. Auch in anderen grossen Gebieten mit hohen
Fallzahlen, wie `}<strong parentName="p">{`Pakistan`}</strong>{`, `}<strong parentName="p">{`Saudi Arabien`}</strong>{` und `}<strong parentName="p">{`Südafrika`}</strong>{`, setzt sich
die Ausbreitung des Virus rasant fort. Die Kurven dieser Länder mit insgesamt
über 87’000 Covid-19-Toten liegen sehr dicht beieinander – dazu gehören
ausserdem `}<strong parentName="p">{`Chile`}</strong>{`, `}<strong parentName="p">{`Mexiko`}</strong>{`, `}<strong parentName="p">{`Kolumbien`}</strong>{` und `}<strong parentName="p">{`Bangladesch`}</strong>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;